import { MIN_SCALE_STEPS } from '../constants.js';

/**
 * Gets whether there is enough space available for tick labels on a scale
 * @param scaleStep - Number of scale steps
 * @returns Whether tick labels have enough available space or not
 */
export function isTickLabelSpaceAvailable(scaleStep: number) {
  return scaleStep === 0 || scaleStep > MIN_SCALE_STEPS;
}
